import styled, { css } from 'styled-components'

interface IModalWrapperProps {
  maxwidth: number
  maxheight: number
  isconfirmation: string
  isInfo: string
}

export const ModalWrapper = styled.div<IModalWrapperProps>`
  .ant-modal {
    max-width: ${(props) => props.maxwidth}px;
    width: 100% !important;
    padding: 10px;
  }
  .ant-modal-content {
    border-radius: 16px;
  }
  .ant-modal-header {
    border-radius: 16px 16px 0 0;
    padding-left: 20px;
    padding-right: 20px;
    border-bottom: none;
    background-color: ${(props) =>
      props.isInfo === 'true' ? '#E7F3FE' : '#fff'};
    ${(props) =>
      props.isconfirmation === 'true' &&
      css`
        background-color: #fff2c7;
      `}
  }
  .ant-modal-title {
    font-size: 16px !important;
    color: #213f68;
    font-weight: 700;
    svg {
      margin-right: 8px;
    }
  }
  .ant-modal-body {
    padding: 0 20px;
    ${(props) =>
      props.isconfirmation === 'true' &&
      css`
        padding-top: 20px;
      `}
    max-height: ${(props) => props.maxheight}px;
    overflow-y: auto;
    color: #202020;
    font-size: 16px;
  }
  .ant-modal-footer {
    padding: 20px;
    border-top: none;
  }
  .ant-row {
    margin-top: -16px !important;
    margin-bottom: -29px !important;
  }
  .ant-modal-mask,
  .ant-modal-wrap {
    z-index: 1020;
  }
`
